import React from 'react'

export default function PaddingLeftRight({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M6 7V13V7Z' fill={color} />
            <path d='M6 7V13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <rect x='3' y='4' width='14' height='12' rx='2' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <path d='M14 7V13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
